import { render, staticRenderFns } from "./link-tree-wine-shipping.vue?vue&type=template&id=552843f8&scoped=true&"
import script from "./link-tree-wine-shipping.vue?vue&type=script&lang=js&"
export * from "./link-tree-wine-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552843f8",
  null
  
)

export default component.exports